<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="6">
            <gg-card-title class="pb-0">
              Support
            </gg-card-title>
          </v-col>
          <v-col cols="12" md="6" class="text-right mt-2">
            <div>
              <gg-btn class="mt-1 mr-1" right :to="{ name: 'support_ticketnew' }">
                Open new ticket
              </gg-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <support-token />
      </v-col>
      <v-col cols="12">
        <ticket-list :pagination="pagination" location="list" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TicketList from 'Components/Support/TicketsList'
import SupportToken from 'Components/Support/SupportToken'

export default {
  components: {
    TicketList,
    SupportToken
  },
  computed: {
    ...mapGetters(['pagination'])
  }
}
</script>
